<template>
  <div :class="{'w-2/3 mx-auto':!fullWidth}">
    <div>
    <button v-text="title" @click="isShowing = !isShowing" :class="{active: isShowing}"></button>
    </div>
    <transition name="accordion"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                v-on:before-leave="beforeLeave"
                v-on:leave="leave">
      <div v-if="isShowing" class="body">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isShowing: false
    }
  },
  props: {
    title: {
      type:String,
      required:true
    },
    fullWidth: {
      type:Boolean,
      default: false
    }
  },
  methods: {
    beforeEnter: function(el) {
      el.style.height = '0';
    },
    enter: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function(el) {
      el.style.height = '0';
    }
  }
}
</script>
<style lang="scss" scoped>
button {
  @apply text-lg relative w-full text-gray-900 border-b border-gray-300 p-4 pl-12 text-left transition-colors duration-500;
  &:hover {
    @apply bg-gray-200 text-orange;
  }
  &:focus {
    @apply outline-none;
  }
  &::after {
    @apply absolute text-lg leading-none;
    top: 50%;
    transform: translateY(-50%);
    left: 15px;
    content: "\002b";
    color: inherit;
  }

  &.active {
    @apply bg-gray-200 text-orange;
    &::after {
      content: "\002d";
    }
  }
}

.body {

  @apply text-left p-4 overflow-hidden transition-all duration-500;


  /*   display: none; */
  overflow: hidden;
  transition: 150ms ease-out;
}


</style>